module.exports = __webpack_public_path__ + "img/ico-grade-silver.24a9cfde.svg";